import { apiService } from "./api";

export interface Category {
  id: string;
  name: string;
  description: string | null;
  displayOrder: number;
  isActive?: boolean;
}

export interface CategoriesResponse {
  categories: Category[];
}

export const categoryService = {
  getAll: async (): Promise<Category[]> => {
    const response = await apiService.get<CategoriesResponse>("/categories");
    return response.categories;
  },
};

